<template>
  <v-layout class="email-create-container">
    <v-layout wrap class="form-wrapper">
      <v-layout wrap>
        <v-flex xs12>
          <div>
            <v-flex class="title-screen">
              <span>Create e-mail</span>
            </v-flex>
            <v-flex x4>
              <div class="title-description screen-description" />
            </v-flex>
            <create-sport-membership-email-form
              :organization-slug="organizationSlug"
              :loading="loading"
              :initial-values="initialValues"
              @onSubmit="createNewEmail"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <success-snackbar
      :open.sync="wasTestEmailSent"
      title="Success"
      message="Your test email was sent successfully to the organizer!"
    />
    <error-snackbar
      :open="emailError"
      title="Oops"
      message="An error occurred while trying to send your email."
    />
  </v-layout>
</template>

<script>
import { EventBus } from '@/plugins/event-bus'
import SuccessSnackbar from '@/components/shared/snackbars/success-snackbar.vue'
import ErrorSnackbar from '@/components/shared/snackbars/errors-snackbar.vue'
import { CREATE_MEMBERSHIP_EMAIL, SEND_MEMBERSHIP_EMAIL } from '@/graphql/email.graphql'
import CreateSportMembershipEmailForm from '@/components/emails/sport-membership-emails-form.vue'
import { isEmpty } from 'lodash'

export default {
  name: 'membership-email-create-container',
  components: {
    CreateSportMembershipEmailForm,
    SuccessSnackbar,
    ErrorSnackbar,
  },
  props: {
    organizationSlug: String,
    eventId: String,
    initialValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      wasTestEmailSent: false,
      emailError: false,
      loading: false,
    }
  },
  methods: {
    async createNewEmail(data) {
      this.loading = true
      const { replyTo, recipientType, subject, content, identifiers } = data

      const email = await this.$apollo.mutate({
        mutation: CREATE_MEMBERSHIP_EMAIL,
        variables: {
          organizationSlug: this.organizationSlug,
          email: {
            replyTo,
            recipientType,
            subject,
            content,
            identifiers: identifiers.length ? identifiers.map(i => i.toString()) : [],
            meta: {
              membershipEmail: true,
            },
          },
        },
      })
      const {
        data: {
          createMembershipEmail: { id },
        },
      } = email


      const response = await this.$apollo.mutate({
        mutation: SEND_MEMBERSHIP_EMAIL,
        variables: {
          emailId: id,
        },
      })
      const {
        data: { sendMembershipEmail },
      } = response

      if (!sendMembershipEmail) {
        this.emailError = true
      } else {
        this.goTo(this.routes.sportOrganization.sportOrganizationMembershipsEmails, { wasEmailSent: true })
        EventBus.$emit('toggle-snackbar', {
          title: 'Success',
          message: 'Your email was sent successfully!',
        })
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.screen-description {
  max-width: 680px;
  margin-bottom: 28px;
}

.form-container {
  margin-right: 30px;
  max-width: 40.75rem;
}

.desktop-shortcodes {
  margin: 352px -60px 0 0;
  min-width: 200px !important;
  display: block !important;
  margin-left: 24px;
}

.email-shortcodes {
  display: none;
}

@media screen and (max-width: 1279px) {
  .desktop-shortcodes {
    display: none !important;
  }

  .email-shortcodes {
    margin: 16px 0;
    margin-bottom: 32px;
    display: block;
  }
}

.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}

.form-wrapper {
  max-width: 40.75rem;
}

@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }

  .form-wrapper {
    margin-top: 24px;
  }
}
</style>
